export var compKey = 'sortable-input-list-item';
//# sourceMappingURL=key.js.map